import { cn } from "@/libs/cn";
import { useNotificationStore } from "@/states/zustand/notification";
import { useEffect } from "react";

const NOTI_DURATION = 3000; // 3 seconds

export function Notification({
    layoutType = "default"
}: {
    layoutType?: "auth" | "default";
}) {

    const noti = useNotificationStore(state => state.notification);

    useEffect(() => {
        // Clear notification after displaying it
        // This is to ensure that the notification does not persist indefinitely
        // and is removed after a certain duration.
        if (noti && noti.message && noti.type) {
            setTimeout(() => {
                useNotificationStore.getState().clearNotification();
            }, NOTI_DURATION);
        }
    }, [noti])

    return (
        <div
            className={cn("fixed top-0 w-[calc(100%-320px)] right-0 z-[9999] p-6 text-center text-base font-poppins font-semibold transform translate-y-[-100%] opacity-20 duration-300 text-white", {
                "w-full": layoutType === "auth",
                "bg-success": noti && noti.type === "success",
                "bg-danger": noti && noti.type === "error",
                "bg-blue-200": noti && noti.type === "info",
                "bg-yellow-300": noti && noti.type === "warning",
                "translate-y-0 opacity-100": noti && noti.message && noti.type
            })}
        >
            {noti && noti.message}
        </div>
    )
}
